import React from "react"
import { Redirect } from "react-router-dom"

import FeatureCatalogsRoute from "../../FeatureCatalogs/FeatureCatalogs"
import ClassificationsRoute from "../../Classifications/Classifications"
import FeatureCatalogViewer from "../../FeatureCatalogViewer/FeatureCatalogViewer"
import ConversionRulesRoute from "../../ConversionRules/ConversionRules"
import ConversionRuleEditorRoute from "../../ConversionRules/ConversionRuleEditor"
import Environment from "./../../../environment"

const routes = [
  {
    routePath: "/featurecatalogs/:id?",
    path: "/featurecatalogs",
    component: FeatureCatalogsRoute,
    breadcrumb: "Feature Catalogs",
    icon: <i className="modus-icons">map_layers</i>
  },
  {
    routePath: "/classifications/:id?",
    path: "/classifications",
    component: ClassificationsRoute,
    breadcrumb: "Classifications",
    icon: <i className="modus-icons">optimize</i>
  },
  {
    routePath: "/featurecatalogdetails/",
    path: "/featurecatalogdetails/",
    component: FeatureCatalogViewer,
    breadcrumb: "Feature Catalog Viewer",
    icon: <i className="modus-icons">list_bulleted</i>
  },
  {
    routePath: "/featurecatalogdetails/:catalog",
    path: "/featurecatalogdetails/:catalog",
    exact: false,
    component: FeatureCatalogViewer,
    breadcrumb: "[FC Name]"
  },
  {
    routePath: "/conversionrules/",
    path: "/conversionrules/",
    component: ConversionRulesRoute,
    breadcrumb: "Conversion Rules",
    icon: <i className="modus-icons">compare_arrows</i>
  },
  {
    routePath: "/conversionrules/:conversionRuleId",
    path: "/conversionrules/:conversionRuleId",
    exact: false,
    component: ConversionRuleEditorRoute,
    breadcrumb: "[CR Name]"
  },
  {
    path: "/",
    component: () => <Redirect to="/featurecatalogs" />,
    breadcrumb: "Home",
    icon: undefined
  }
]

if (!Environment.showConversionRuleEditor) {
  routes.splice(4, 2)
}
if (!Environment.showClassification) {
  routes.splice(1, 1)
}

export default routes
